import { useEffect, useMemo, useState } from "react";
import { FilmSlate } from "@phosphor-icons/react";

const YT_ID = /(?:youtube(?:-nocookie)?\.com\/(?:embed\/|watch\?v=|shorts\/|live\/)|youtu\.be\/|i\.ytimg\.com\/vi\/)([\w-]{11})/;

export const youtubeId = (...urls) => {
  for (const u of urls) {
    const m = (u || "").match(YT_ID);
    if (m) return m[1];
  }
  return null;
};

// Compact 120x68 admin thumbnail: YouTube maxres -> hq -> saved image -> ReelVault placeholder.
export const AdminThumb = ({ url, thumb, testid }) => {
  const sources = useMemo(() => {
    const id = youtubeId(url, thumb);
    const yt = id ? [`https://i.ytimg.com/vi/${id}/maxresdefault.jpg`, `https://i.ytimg.com/vi/${id}/hqdefault.jpg`] : [];
    return [...yt, thumb].filter((s, i, a) => s && a.indexOf(s) === i);
  }, [url, thumb]);
  const [idx, setIdx] = useState(0);
  useEffect(() => setIdx(0), [sources]);
  const src = sources[idx];
  // YouTube serves a 120x90 grey stub (not a 404) for missing frames.
  const onLoad = (e) => src.includes("ytimg.com") && e.currentTarget.naturalWidth <= 120 && setIdx((i) => i + 1);

  return (
    <div data-testid={testid} className="relative h-[68px] w-[120px] shrink-0 overflow-hidden rounded-sm border border-white/10 bg-[#111]">
      {src ? (
        <img src={src} alt="" loading="lazy" onLoad={onLoad} onError={() => setIdx((i) => i + 1)} className="h-full w-full object-cover" />
      ) : (
        <div data-testid={testid && `${testid}-fallback`} className="grid h-full w-full place-items-center bg-gradient-to-br from-amber/10 to-crimson/10">
          <FilmSlate size={22} weight="duotone" className="text-amber/70" />
        </div>
      )}
    </div>
  );
};
